export const ANNOTATION_SHAPE_TYPE = {
  POINT: 'POINT',
  POLYLINE: 'POLYLINE',
  POLYGON: 'POLYGON',
};
export type AnnotationShapeType = keyof typeof ANNOTATION_SHAPE_TYPE;

export const ANNOTATION_FIELD_TYPE = {
  FILE: 'FILE',
  TEXT: 'TEXT',
  DATE: 'DATE',
  SELECT: 'SELECT',
  URL: 'URL',
  IMAGE: 'IMAGE',
} as const;
export type AnnotationFieldType = keyof typeof ANNOTATION_FIELD_TYPE;

export const ANNOTATION_TEMPLATE_CREATED_BY = {
  SYSTEM: 'SYSTEM',
  USER: 'USER',
};
export type AnnotationTemplateCreatedBy = keyof typeof ANNOTATION_TEMPLATE_CREATED_BY;

export const DND_ITEM_TYPE = {
  CHIP: 'CHIP',
  FIELD: 'FIELD',
  OPTION: 'OPTION',
};
export type DndItemType = keyof typeof DND_ITEM_TYPE;

export interface AnnotationFieldMetadata {
  type: string;
  placeholder: string;
  defaultValue?: string;
}

export const ANNOTATION_FIELD_CONFIG: Record<AnnotationFieldType, AnnotationFieldMetadata> = {
  TEXT: {
    type: 'text',
    placeholder: 'Enter text field name (e.g., Description)',
    defaultValue: '',
  },
  DATE: {
    type: 'date',
    placeholder: 'Enter date field name (e.g., Due Date)',
    defaultValue: '',
  },
  SELECT: {
    type: 'select',
    placeholder: 'Enter dropdown field name (e.g., Status)',
    defaultValue: '',
  },
  FILE: {
    type: 'file',
    placeholder: 'Enter attachment field name (e.g., Document)',
    defaultValue: '',
  },
  URL: {
    type: 'url',
    placeholder: 'Enter link field name (e.g., Reference URL)',
    defaultValue: '',
  },
  IMAGE: {
    type: 'image',
    placeholder: 'Enter image field name (e.g., Preview)',
    defaultValue: '',
  },
} as const;

export const OPTION_FIELD_CONFIG = {
  inputPlaceholder: 'Enter option value',
} as const;
